module.exports = __webpack_public_path__ + "img/hiker.d508b842.svg";